import { render } from "./FoundCard.vue?vue&type=template&id=0210b25d"
import script from "./FoundCard.vue?vue&type=script&lang=js"
export * from "./FoundCard.vue?vue&type=script&lang=js"

import "./FoundCard.vue?vue&type=style&index=0&id=0210b25d&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__